export default toolbar = {
    options: ['inline', 'blockType', 'list', 'textAlign', 'image', "remove"],
    inline: { inDropdown: true },
    list: { inDropdown: true },
    textAlign: { inDropdown: true },
    link: { inDropdown: true },
    history: { inDropdown: true },
}